import * as React from 'react'
import {Visibility, ThumbUp, ThumbDown} from '@material-ui/icons'
import * as styles from './styles.module.css'

const JetsoStats = ({type, stats}) => {
  const getIcon = () => {
    if (type === 'views') {
      return (
        <Visibility />
      )
    }
    if (type === 'likes') {
      return (
        <ThumbUp />
      )
    }
    if (type === 'dislikes') {
      return (
        <ThumbDown />
      )
    }
    return (
      <></>
    )
  }
  const showStats = () => {
    if (stats >= 1000000) {
      return `${(stats / 1000000).toFixed(1)}M`
    }
    if (stats >= 10000) {
      return `${(stats / 1000).toFixed(1)}K`
    }
    return stats
  }
  return (
    <div className={styles.statsRoot}>
      {getIcon()}
      <p>{showStats()}</p>
    </div>
  )
}

export default JetsoStats